var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit',{attrs:{"classify":_vm.classify,"classify-name":_vm.classifyName,"apply-is-virtual":_vm.isVirtual}})
}
var staticRenderFns = []

export { render, staticRenderFns }